module.exports = __webpack_public_path__ + "static/media/모의고사.60eecf94.png";